var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.showModule === 0)?_c('module-0',{attrs:{"module":this.module,"category":this.category}}):_vm._e(),(_vm.showModule === 1)?_c('module-1',{attrs:{"module":this.module,"category":this.category}}):_vm._e(),(_vm.showModule === 2)?_c('module-2',{attrs:{"module":this.module,"category":this.category}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }